import { FuelSource } from "./FuelSource.js";

export enum DecarbonizationPillar {
  EnergyEfficiency = "ee",
  Electrification = "el",
  LowCarbonFuels = "lcf",
  CarbonCapture = "ccus",
}

export enum Scope {
  Scope1 = 1,
  Scope2 = 2,
  Scope3 = 3,
}

export enum CostScore {
  One = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  Five = 5,
}

export type SolutionOption = {
  label: string;
  name: string;
  pillar: DecarbonizationPillar;
  targetedFuelSource: FuelSource;
  description: string;
  scope: Scope;
  costScore: CostScore;
};

export type Solution = SolutionOption & {
  value: number;
};

export enum SolutionOptionKey {
  EnergyEfficiencyAndHeatRecoveryElectricity = "energyEfficiencyAndHeatRecoveryElectricity",
  EnergyEfficiencyAndHeatRecoveryNaturalGas = "energyEfficiencyAndHeatRecoveryNaturalGas",
  EnergyEfficiencyAndHeatRecoveryPropane = "energyEfficiencyAndHeatRecoveryPropane",
  EnergyEfficiencyAndHeatRecoveryFuelOil = "energyEfficiencyAndHeatRecoveryFuelOil",
  EnergyEfficiencyAndHeatRecoveryDiesel = "energyEfficiencyAndHeatRecoveryDiesel",
  EnergyEfficiencyAndHeatRecoveryGasoline = "energyEfficiencyAndHeatRecoveryGasoline",
  StationaryElectrificationNaturalGas = "stationaryElectrificationNaturalGas",
  StationaryElectrificationPropane = "stationaryElectrificationPropane",
  StationaryElectrificationFuelOil = "stationaryElectrificationFuelOil",
  MobileElectrificationDiesel = "mobileElectrificationDiesel",
  MobileElectrificationGasoline = "mobileElectrificationGasoline",
  LowNoCarbonFuelSwitchingNaturalGas = "lowNoCarbonFuelSwitchingNaturalGas",
  LowNoCarbonFuelSwitchingPropane = "lowNoCarbonFuelSwitchingPropane",
  LowNoCarbonFuelSwitchingFuelOil = "lowNoCarbonFuelSwitchingFuelOil",
  LowNoCarbonFuelSwitchingGasoline = "lowNoCarbonFuelSwitchingGasoline",
  LowNoCarbonFuelSwitchingDiesel = "lowNoCarbonFuelSwitchingDiesel",
  CoGenerationElectricity = "coGenerationElectricity",
  RenewablePurchaseFromUtilityElectricity = "renewablePurchaseFromUtilityElectricity",
  RenewableEnergyAsPpaVppaElectricity = "renewableEnergyAsPpaVppaElectricity",
  RenewableCreditsRecsElectricity = "renewableCreditsRecsElectricity",
  OnsiteSolarOrRenewableEnergyGenerationElectricity = "onsiteSolarOrRenewableEnergyGenerationElectricity",
  CarbonCaptureAndSequestrationCarbon = "carbonCaptureAndSequestrationCarbon",
  EliminateFugitiveEmissionsCarbon = "eliminateFugitiveEmissionsCarbon",
  OffsetsCarbon = "offsetsCarbon",
  RefrigerantLeaksRefrigerants = "refrigerantLeaksRefrigerants",
  LowGwpRefrigerantsRefrigerants = "lowGwpRefrigerantsRefrigerants",
}

export type SolutionMap = Partial<Record<SolutionOptionKey, number>>;
